import { render, staticRenderFns } from "./Stu_Collect.vue?vue&type=template&id=cf389d1c&scoped=true"
import script from "./Stu_Collect.vue?vue&type=script&lang=js"
export * from "./Stu_Collect.vue?vue&type=script&lang=js"
import style0 from "./Stu_Collect.vue?vue&type=style&index=0&id=cf389d1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf389d1c",
  null
  
)

export default component.exports